import client from './client'

export function fetchCompletions(trackId) {
  return client.get(`/api/v1/tracks/${trackId}/completions`)
}

export function createCompletion(trackId, { completedAt, vehicleId, vehicle, photos = [] }) {
  if (vehicle) {
    const formData = new FormData()
    formData.append('completed_at', completedAt)
    formData.append('vehicle[make]', vehicle.make)
    if (vehicle.equipment) formData.append('vehicle[equipment]', vehicle.equipment)
    photos.forEach((photo) => formData.append('photos[]', photo))
    return client.post(`/api/v1/tracks/${trackId}/completions`, formData)
  }

  return client.post(`/api/v1/tracks/${trackId}/completions`, {
    completion: {
      completed_at: completedAt,
      vehicle_id: vehicleId,
    },
  })
}

export function deleteCompletion(trackId, completionId) {
  return client.delete(`/api/v1/tracks/${trackId}/completions/${completionId}`)
}
